import useCurrentResourceCentre from "./useCurrentResourceCentre";

const useDaybookSubscription = (): { isDayBookSubscribed: boolean } => {
  const rc = useCurrentResourceCentre();

  const daybook = rc?.subscription?.features?.daybook;

  return {
    isDayBookSubscribed: daybook?.subscribed ?? false // Default to false if not defined
  };
};

export default useDaybookSubscription;
